export default "__VITE_ASSET__6aeee4c9__"